import { render, staticRenderFns } from "./payment_description_input.vue?vue&type=template&id=7490d1e4&scoped=true"
import script from "./payment_description_input.vue?vue&type=script&lang=js"
export * from "./payment_description_input.vue?vue&type=script&lang=js"
import style0 from "./payment_description_input.vue?vue&type=style&index=0&id=7490d1e4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7490d1e4",
  null
  
)

export default component.exports